const isFunction = functionToCheck => {
  return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
};

const replaceBraces = filters => {
  let result = `(${filters})`;
  while (result.indexOf('((') >= 0 || result.indexOf('))') >= 0 || result.indexOf('(!(') >= 0) {
    result = result
      .replace('((', '(')
      .replace('(~(', '~(')
      .replace('))', ')');
  }
  return result;
};

const serializeFilter = (filter, dataField) => {
  if (!filter) return '';

  let result = '';

  if (!Array.isArray(filter)) return filter;

  let lastItem = null;
  for (let i = 0; i < filter.length; ++i) {
    if (Array.isArray(filter[i])) {
      if (Array.isArray(lastItem)) result += '&';
      result += `(${serializeFilter(filter[i], dataField)})`;
    } else if (isFunction(filter[i])) {
      // search in filter
      result += filter[i]() || dataField;
    } else if (i === 1 && filter[i] === 'contains') result += `__i${filter[i]}=`;
    else if (i === 1 && filter[i] === '<') result += '__lt=';
    else if (i === 1 && filter[i] === '<=') result += '__lte=';
    else if (i === 1 && filter[i] === '>') result += '__gt=';
    else if (i === 1 && filter[i] === '>=') result += '__gte=';
    else if (filter[i] === '!') result += '~';
    else if (filter[i] === 'and') result += '&';
    else if (filter[i] === 'or') result += '|';
    else result += filter[i];

    lastItem = filter[i];
  }
  return replaceBraces(result);
};

export default serializeFilter;
